import React from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../Arrangement/colabSVG.svg";
import "./Navbar.css";
import { Navbar, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";

function Navigation({ logout }) {
  const currentUser = useSelector((st) => st.user.currentUser);

  function loggedInNav() {
    return (
      //   <ul className="navbar-nav ml-auto">
      //     <li className="nav-item mr-4">
      //       <NavLink className="nav-link" to={`/dashboard`}>
      //         Dashboard
      //       </NavLink>
      //     </li>
      //     <li className="nav-item mr-4">
      //       <NavLink className="nav-link" to="/profile">
      //         Profile
      //       </NavLink>
      //     </li>
      //     <li className="nav-item">
      //       <Link className="nav-link" to="/" onClick={() => console.log("loggedOut")}>
      //         Log out
      //       </Link>
      //     </li>
      //   </ul>
      <>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <div className="nav-link">
              <NavLink className="nav-link" to={`/dashboard`}>
                Dashboard
              </NavLink>
            </div>
            <div className="nav-link">
              <NavLink className="nav-link" to="/profile">
                Profile
              </NavLink>
            </div>

            <div className="nav-link">
              <Link className="nav-link" to="/login" onClick={logout}>
                Log out
              </Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </>
    );
  }
  function loggedOutNav() {
    return (
      <>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="ml-auto"
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <div eventkey="0">
              <NavLink className="nav-link" exact to="/">
                Home
              </NavLink>
            </div>
            <div eventkey="1">
              <NavLink className="nav-link" exact to="/login">
                Login
              </NavLink>
            </div>
            <div eventkey="2">
              <NavLink className="nav-link" exact to="/register">
                Sign Up
              </NavLink>
            </div>
          </Nav>
        </Navbar.Collapse>
      </>
    );
  }

  return (
    <Navbar sticky="top" collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Navbar.Brand>
        <Link
          to={currentUser.username ? "/dashboard" : "/"}
          style={{ color: "white", textDecoration: "none" }}
        >
          <img
            src={Logo}
            width="30"
            height="30"
            className="d-inline-block align-top img"
            alt="React Bootstrap logo"
          />{" "}
          COLAB
        </Link>
      </Navbar.Brand>

      {currentUser.username ? loggedInNav() : loggedOutNav()}
    </Navbar>
  );
}

export default Navigation;
